import { useState } from 'react'
import { searchStateData } from '../../data/searchStateData'
import { useAppDispatch } from '../../redux/hooks'
import { searchDataUpdated, toggleAppShowSearchMenu, updateQuickSearchValues } from '../../redux/reducers/searchSlice'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
import '../../style/explore/style-app-explore-menus.scss'
import AppRangeSliderBasic from '../app_rangeSliderBasic/AppRangeSliderBasic'

// interface AppSearchMenuProps {
// 	close
// }

function AppSearchMenu() {
	const [groupSizeValue, setGroupSizeValue] = useState<number | undefined>(searchStateData.quickSearchOptions[0].value !== undefined ? searchStateData.quickSearchOptions[0].value as number : undefined)
	const [levelValue, setLevelValue] = useState<number[] | undefined>(searchStateData.quickSearchOptions[1].value !== undefined ? searchStateData.quickSearchOptions[1].value as number[] : undefined)
	const [schoolValue, setSchoolValue] = useState<number | undefined>(searchStateData.quickSearchOptions[2].value !== undefined ? searchStateData.quickSearchOptions[2].value as number : undefined)
	const [instructorName, setInstructorName] = useState<string>(searchStateData.quickSearchOptions[3].value !== undefined ? searchStateData.quickSearchOptions[3].value as string : '')

	const dispatch = useAppDispatch()

	const closeButtonClickHandler = () => {
		dispatch(toggleAppShowSearchMenu())
	}

	const groupSizeSelectHandler = (newValue: number) => {
		if (searchStateData.quickSearchOptions[0].value === newValue) {
			searchStateData.quickSearchOptions[0].value = undefined
		} else {
			searchStateData.quickSearchOptions[0].value = newValue
		}
		setGroupSizeValue(searchStateData.quickSearchOptions[0].value)
		dispatch(updateQuickSearchValues())
	}
	const levelValueChangeHandler = (newValue: number[] | undefined) => {
		searchStateData.quickSearchOptions[1].value = newValue
		setLevelValue(newValue)
		dispatch(updateQuickSearchValues())
	}
	const schoolSelectHandler = (newValue: number) => {
		if (searchStateData.quickSearchOptions[2].value === newValue) {
			searchStateData.quickSearchOptions[2].value = undefined
		} else {
			searchStateData.quickSearchOptions[2].value = newValue
		}
		setSchoolValue(searchStateData.quickSearchOptions[2].value)
		dispatch(updateQuickSearchValues())
	}
	const instructorNameUpdate = (newValue: string) => {
		if (newValue === '') {
			searchStateData.quickSearchOptions[3].value = undefined
			setInstructorName('')
		} else {
			searchStateData.quickSearchOptions[3].value = newValue
			setInstructorName(newValue)
		}
	}

	const clearSearchButtonClickHandler = () => {
		// searchStateData.clearExistingProfiles()
		searchStateData.clearAllQuickSearchOptions()
		setSchoolValue(undefined)
		setGroupSizeValue(undefined)
		setInstructorName('')
		setLevelValue(undefined)
		// instructorSearchConnector.performSearchRequest().then((successRequest) => {
		// 	dispatch(searchDataUpdated())
		// 	if (!successRequest) {
		// 		console.log('WARNING - [App] - performSearchRequest() failed')
		// 	}
		// })
	}

	const quickSearchButtonClickHandler = () => {
		searchStateData.clearExistingProfiles()
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			dispatch(searchDataUpdated())
			closeButtonClickHandler()
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	return (
		<div className='app-quick-search-background'>
			<div className={'app-quick-search-wrap'}>
				<div className='app-quick-search-title'>Explore</div>
				<img
					className='app-quick-search-close'
					src='/imgs/icons/explore/icon-x.svg'
					alt='close'
					onClick={() => {
						closeButtonClickHandler()
					}}
				/>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Who</div>
					<input 
						className='app-quick-search-menu-item-input'
						placeholder='Search instructor ...'
						value={instructorName}
						onChange={(event) => {
							instructorNameUpdate(event.target.value)
						}}
					></input>
					<img
						className='app-quick-search-menu-item-arrow'
						src='/imgs/icons/explore/icon-menu-arrow.svg'
						alt='arrow'
					/>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Ski School</div>
					<select 
						className='app-quick-search-menu-item-select'
						value={schoolValue !== undefined ? schoolValue : 0}
						onChange={(event) => {
							schoolSelectHandler(parseInt(event.target.value) as number)
						}}
					>
						{/* <option value="" selected disabled>Search ski school ...</option> */}
						{searchStateData.quickSearchOptions[2].valueLabels.map((valueLabel: string, index: number) => 
							<option 
								value={index as number} 
								disabled={index === 0} 
								key={`schoolOption${index}`}
							>{valueLabel === 'None' ? 'Search ski school ...' : valueLabel}</option>
						)}
					</select>
					<img
						className='app-quick-search-menu-item-arrow'
						src='/imgs/icons/explore/icon-menu-arrow.svg'
						alt='arrow'
					/>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Group Size</div>
					<div className='app-quick-search-menu-item-button-wrap'>
						<button 
							className={`app-quick-search-menu-item-button ${groupSizeValue === 0 ? 'selected' : ''}`}
							onClick={() => {groupSizeSelectHandler(0)}}
						>1</button>
						<button 
							className={`app-quick-search-menu-item-button ${groupSizeValue === 1 ? 'selected' : ''}`}
							onClick={() => {groupSizeSelectHandler(1)}}
						>2</button>
						<button 
							className={`app-quick-search-menu-item-button ${groupSizeValue === 2 ? 'selected' : ''}`}
							onClick={() => {groupSizeSelectHandler(2)}}
						>3</button>
					</div>
				</div>
				<div className='app-quick-search-menu-item'>
					<div className='app-quick-search-menu-item-title'>Instructor Level</div>
					<AppRangeSliderBasic
						valueLabels={['lvl 1', 'lvl 2', 'lvl 3', 'lvl 4']}
						value={levelValue} // [0,3]}
						onValueUpdate={(newValue: number[] | undefined) => {
							// console.log(selectedValues)
							// console.log(newValue)
							levelValueChangeHandler(newValue)
						}}
					/>
				</div>
				<div className='app-quick-search-bottom-wrap'>
					<div className='app-quick-search-bottom-gradient' />
					<button 
						className={'app-quick-search-bottom-button-white'}
						onClick={(event) => { 
							event.stopPropagation()
							clearSearchButtonClickHandler()
						}}
					>
						<div className='app-quick-search-bottom-button-label'>Clear all</div>
					</button>
					<button 
						className={'app-quick-search-bottom-button-blue'}
						onClick={(event) => { 
							event.stopPropagation()
							quickSearchButtonClickHandler()
						}}
					>
						<div className='app-quick-search-bottom-button-label'>Show Instructors</div>
					</button>
				</div>
			</div>
		</div>
	)
}

export default AppSearchMenu
